"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { AUTH_EVENT_COOKIE } from "@/lib/analytics/consent";
import { trackEvent } from "@/lib/analytics/events";

/** Reports the server's `login` note on the page a sign-in lands on, then
 *  deletes it (lib/analytics/consent.ts says why it is a cookie). Mounted with
 *  GA4; re-checked on every navigation, since a Server Action's redirect is
 *  an App Router navigation, not a page load. */
export function AuthEvent() {
  const path = usePathname();
  useEffect(() => {
    const raw = document.cookie
      .split(";")
      .map((p) => p.trim())
      .find((p) => p.startsWith(`${AUTH_EVENT_COOKIE}=`));
    if (!raw) return;
    document.cookie = `${AUTH_EVENT_COOKIE}=;path=/;max-age=0`;
    const [event, method] = decodeURIComponent(raw.slice(AUTH_EVENT_COOKIE.length + 1)).split(":");
    if (event === "login" && method) trackEvent("login", { method });
  }, [path]);
  return null;
}
